import styled from 'styled-components';

export const StyledControlPanelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  width: 100%;
  margin-top: 10px;

  p {
    justify-self: start;
  }
`;
